import React, { useContext } from "react";
import calcOverall from "../tools/calcOverall";
import { WatchContext } from "../WatchContext";
import FloatCard from "./ui/FloatCard";

const OverallStatus = () => {
  const { horizontal, vertical, hydrology, biology } = useContext(WatchContext);

  let topicArray = [horizontal, vertical, hydrology, biology]
  let overallStatus = calcOverall(topicArray)

  return (
    <FloatCard
      height="100%"
      bgColor={overallStatus.color}
      margin="1rem"
      width="200px"
    >
      <h2 style={{margin: '2rem', textAlign: 'center'}}>Overall Status</h2>
      <span style={{ textAlign: "left", fontWeight: 'bold' }}>{overallStatus.title}</span><span style={{ textAlign: "left" }}>{overallStatus.message}</span>
    </FloatCard>
  );
};

export default OverallStatus;
